<template>
  <div class="d-flex">
    <!-- Left Form -->
    <div class="w-50 p-4 bg-white">
      <h4 class="mb-3">Customize Appreciation Card</h4>
      <form @submit.prevent>
        <!-- Upload Logo -->
        <div class="form-group mb-3">
          <label>Upload Logo</label>
          <input type="file" class="form-control" @change="onLogoChange" />
        </div>

        <!-- Upload Image -->
        <div class="form-group mb-3">
          <label>Upload Image</label>
          <input type="file" class="form-control" @change="onFileChange" />
        </div>

        <!-- Title -->
        <div class="form-group mb-3">
          <label>Title</label>
          <input type="text" class="form-control" v-model="formData.title" />
        </div>

        <!-- Message -->
        <div class="form-group mb-3">
          <label>Message</label>
          <textarea class="form-control" rows="3" v-model="formData.greeting"></textarea>
        </div>

        <!-- Sender -->
        <!-- <div class="form-group mb-3">
          <label>Sender</label>
          <input type="text" class="form-control" v-model="formData.sender" />
        </div> -->

        <!-- Action Buttons -->
        <div class="d-flex justify-content-between mt-5">
          <button type="button" class="btn btn-secondary" @click="resetForm">Reset to Default</button>
          <button type="button" class="btn btn-primary" @click="update_card">Change</button>
        </div>
      </form>
    </div>

    <!-- Right Phone Container -->
    <div v-if="formData" class="w-50 d-flex justify-content-center align-items-center min-vh-70 bg-light">
      <div class="phone-frame d-flex justify-content-center align-items-center">
        <div class="card shadow-lg border-0 w-100" style="border: 10px solid #009688">
          <div class="card-body text-center p-4">
            <!-- Logo (always above image) -->
            <div v-if="formData.logo" class="mb-3">
              <img :src="formData.logo" alt="Logo" class="logo-img" />
            </div>

            <!-- Main Image -->
            <div class="mb-3">
              <img :src="formData.image" alt="AppreciationImage" class="main-img" />
            </div>

            <!-- Title -->
            <h5 class="card-title font-weight-bold">{{ formData.title }}</h5>

            <!-- Message -->
            <p class="card-text text-muted mb-4">{{ formData.greeting }}</p>

            <!-- Sender -->
            <p class="text-secondary small mb-0">- {{ formData.sender }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppreciationCard",
  data() {
    return {
      defaultData: {
        title: "Appreciation Title!",
        greeting: "Appreciation Message",
        sender: "Stara",
        image: "https://cdn-icons-png.flaticon.com/512/3468/3468377.png",
        logo: "https://cdn-icons-png.flaticon.com/512/5968/5968267.png", // default logo
      },
      formData: {},
      file1: null,
      file2: null,
      new: false,
    };
  },
  mounted() {
    this.get_appre();
  },
  methods: {
    async get_appre() {
      let vm = this;
      vm.new = true;
      vm.formData = null;
      let bday = await vm.$axios("/appreciationCard/");
      let x = bday.data.data[0];
      let kode = this.$store.state.kode_client === "shortcut" ? "shorcuthr" : this.$store.state.kode_client;

      let ip = kode ? `https://${kode}.storage.googleapis.com/` : null;
      if (x) {
        vm.formData = x;
        vm.formData.logo = x.logo ? ip + x.logo : null;
        vm.formData.image = x.image ? ip + x.image : null;
      } else {
        vm.new = true;
        vm.formData = vm.defaultData;
      }
    },
    update_card() {
      let vm = this;
      let formD = new FormData();
      formD.append("id", vm.formData.id);
      formD.append("title", vm.formData.title);
      formD.append("file1", vm.file1);
      formD.append("file2", vm.file2);
      formD.append("greeting", vm.formData.greeting);
      let link = vm.new ? "/appreciationcard/register" : "/appreciationcard/update";
      vm.$axios
        .post(link, formD)
        .then((res) => {
          this.$store.commit("set_alert", {
            variant: res.data.message === "sukses" ? "success" : "danger",
            msg: res.data.message === "sukses" ? "BERHASIL MENGUPDATE BIRTHDAY CARD" : res.data.message.toUpperCase(),
            showing: true,
          });
          this.$bvModal.hide("modal-input");
        })
        .catch((err) => {
          this.$store.commit("set_alert", {
            variant: "danger",
            msg: err.message.toUpperCase(),
            showing: true,
          });
        })
        .finally(() => {
          this.get_appre();
          // this.busy = false;
          // this.button = this.$store.state.form.simpan;
        });
    },
    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.formData.image = URL.createObjectURL(file);
        this.file2 = file;
      }
    },
    onLogoChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.formData.logo = URL.createObjectURL(file);
        this.file1 = file;
      }
    },
    resetForm() {
      this.formData = { ...this.defaultData };
    },
    applyChange() {
      alert("Changes applied!");
    },
  },
};
</script>

<style scoped>
body {
  background-color: #f0f8ff;
}

.phone-frame {
  background: #111;
  border-radius: 35px;
  padding: 20px 12px;
  width: 380px;
  height: 700px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  position: relative;
}

/* Top notch */
.phone-frame::before {
  content: "";
  display: block;
  width: 150px;
  height: 25px;
  background: #111;
  border-radius: 12px;
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
}

/* Inner screen */
.phone-frame .card {
  border-radius: 25px;
  overflow: hidden;
}

.logo-img {
  max-height: 60px;
  object-fit: contain;
}

.main-img {
  max-height: 240px;
  max-width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}
</style>
